import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {darkGray} from '/theme/color/on.color';
import {getFontFamily} from '/util/text.util';

export const styles = StyleSheet.create({
  taskListContainer: {
    paddingTop: indent,
  },
  weeklyCheckInsText: {
    fontSize: 14,
    fontWeight: '400',
    marginTop: indent * 0.6,
    lineHeight: 20,
    color: darkGray,
  },
  // @ts-expect-error TS(2322): Type '{ fontFamily: string; fontWeight: string | undefined; }' is not assignable.
  selectedText: {
    ...getFontFamily('regular'),
  },
  loader: {
    marginTop: indent * 2,
  },
});
